import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Slider } from '../../../components/atoms';
import { LoadingView } from '../../../../common/components/atoms';
import { HeaderTraining, HelpDialog, FooterTraining } from '../../../components/molecues';
import { Training1, Training2, Training3, Training4, Training5 } from '../';
import { STUDY_STATE } from '../../../common/constants.js';
import AudioRecorderPolyfill from "audio-recorder-polyfill";

import { getMondayDate} from '../../../../common/helper/commonHelper.js';

class Training extends Component {
    constructor(props) {
        super(props);

        this.refSlider = React.createRef();
        this.refTraining1 = React.createRef();
        this.refTraining2 = React.createRef();
        this.refTraining3 = React.createRef();
        this.refTraining4 = React.createRef();
        this.state = {
            current: 0,
            subject: null,
            menuDisplay: false,
            playbackRate: this.props.playbackRate ? this.props.playbackRate : 1.0,

            sendCount: this.props.sendCount ? this.props.sendCount : 0,
            sendMax: this.props.sendMax ? this.props.sendMax : 0,
            helpDisplay: false,
            voiceChangeMark: "",
            weeksGoalId: 0,
        }
        let userAgent = window.navigator.userAgent.toLowerCase();
        if(userAgent.indexOf("iphone")  !== -1 || (userAgent.indexOf("chrome") === -1 && userAgent.indexOf("safari") !== -1)) {
            if(!window.MediaRecorder){
                window.MediaRecorder = AudioRecorderPolyfill;
            }
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
		this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: "GetVocabularyList_Saga",
            subjectID: this.props.subject.id,
            onSuccess: this.onSuccessGetVocabulary,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetChunkList_Saga",
            subjectID: this.props.subject.id,
            onSuccess: this.onSuccessGetChunk,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetRecordHistory_Saga",
            id: this.props.user.id,
            subjectID: this.props.subject.id,
            onSuccess: this.onSuccessGetHistory,
            onFailure: this.onFailure,
        });
    }
    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        let order = 0;
        for (let key in list) {
            list[key].order = order;
            order++;
        }
        return list;
    }
    onSuccessGetVocabulary = (vocabulary) => {
        this.props.dispatch({
            type: "LoadVocabulary",
            vocabulary: this.getSortedList(vocabulary),
        });
        this.refTraining2.current.loadStart();
    }
    onSuccessGetChunk = (chunk) => {
        this.props.dispatch({
            type: "LoadChunk",
            chunk: this.getSortedList(chunk),
        });
        this.refTraining3.current.loadStart();
    }
    onSuccessGetHistory = (history) => {
        this.loadingRecordHistory = false;
        this.props.dispatch({
            type: 'SaveRecord',
            records: history,
        });
        this.refTraining4.current.loadStart();
    }
    onLoadedFullText = (audio) => {
        this.refTraining4.current.loadedFullText(audio);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let res = {};
        if (prevState.sendCount !== nextProps.sendCount) {
            res.sendCount = prevState.sendCount !== nextProps.sendCount ? nextProps.sendCount : prevState.sendCount;
        }
        return res;
    }

    onFailure = (status, error) => {
    }

    createContents(index) {
        const width = window.parent.screen.width + "px";
        // height HeaderTraining:110 FooterTraining:50
        const height = (window.parent.screen.height - 110 - 50) + "px";
        return (
            <SliderContents key={index} Width={width} Height={height} style={{ backgroundColor: "#fdd" }}>
                {index}
            </SliderContents>
        );
    }
    onSliderChanged = (current) => {
        this.setState({ current: current });
    }

    onClickBack = () => {
        this.props.history.replace({pathname: '/top', state: {referrer: '/training'}});
    }

    onClickMenu = () => {
        this.setState({ menuDisplay: true });
    }

    closeMenu = () => {
        this.setState({ menuDisplay: false });
    }

    onClickHelp = (voiceChangeMark) => {
        this.setState({ 
            helpDisplay: true,
            voiceChangeMark: voiceChangeMark
        });
    }

    closeHelp = () => {
        this.setState({ helpDisplay: false });
    }

    onClickNext = () => {
        // weeksGoalId設定処理
        let today = new Date();
        let MondayDate = getMondayDate(today);

        this.props.dispatch({
            type: "GetWeeksGoal_Saga",
            userID: this.props.user.id,
            date: MondayDate,
            onSuccess: this.onSuccessGetWeeksGoal,
            onFailure: this.onFailure,
        });
    }

    onSuccessGetWeeksGoal = (items) => {
        this.setState({ weeksGoalId: items[0].id });
        if (this.state.current === 4){
            this.finishTraining();
        } else {
            this.nextTraining();
        } 
    }

    nextTraining = () => {
        let current = this.state.current;
        let nowStudyState = this.props.subject.userStatus.studyState;

        // studeStatusが1(完了)の場合は更新しない
        if (nowStudyState !==  1){
            // SubjectUserStatusテーブルのstudeStatusより進捗が進んだ場合データを更新
            if(nowStudyState < (current + 2)){
                let updateStudyState = (current + 2);
        
                this.props.dispatch({
                    type: "LoadStart"
                });
                this.props.dispatch({
                    type: 'SetStudyState_Saga',
                    subjectId: this.props.subject.id,
                    studyState: updateStudyState,
                    weeksGoalId: this.state.weeksGoalId,
                    onSuccess: this.onSuccessStudyState(updateStudyState),
                    onFailure: this.onFailureStudyState,
                });
            }
        }
        current++;
        if (current >= 5) {
            current = 4;
        }
        this.setState({ current: current });
        this.refSlider.current.goNext();
    }

    onSuccessStudyState = (studyState) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let subject = this.props.subject;
        subject.userStatus.studyState = studyState;
        this.props.dispatch({
            type: "LoadSubject",
            subject: subject,
        });
    }
    onFailureStudyState = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickPrev = () => {
        let current = this.state.current;

        current--;
        if (current < 0) {
            current = 0;
        }
        this.setState({ current: current });
        this.refSlider.current.goPrev();
    }

    finishTraining = () => {
        let nowStudyState = this.props.subject.userStatus.studyState;

        // studeStatusが1(完了)の場合は更新しない
        if (nowStudyState !==  1){
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: 'SetStudyState_Saga',
                subjectId: this.props.subject.id,
                studyState: STUDY_STATE.DONE,
                weeksGoalId: this.state.weeksGoalId,
                onSuccess: this.onSuccessFinish,
                onFailure: this.onFailureStudyState,
            });
        } else {
            this.onClickBack();
        }
    }
    onSuccessFinish = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let subject = this.props.subject;
        subject.userStatus.studyState = STUDY_STATE.DONE;
        this.props.dispatch({
            type: "LoadSubject",
            subject: subject,
        });
        this.onClickBack();
    }

    onChangePlaybackRate = (rate) => {
        this.props.dispatch({
            type: "PlaybackRate",
            playbackRate: rate
        });
    }

    render() {
        const width = window.parent.screen.width + "px";
        // header:110 footer:50
        const height = (window.innerHeight - 110 - 50) + "px";
        const propsTrainig = {
            dispatch: this.props.dispatch,
            user: this.props.user,
            subject: this.props.subject,
            vocabulary: this.props.vocabulary,
            chunk: this.props.chunk,
            width: width,
            height: height,
            playbackRate: this.state.playbackRate,
            onChangePlaybackRate: this.onChangePlaybackRate,
        }
        let contents = [
            (<Training1 ref={this.refTraining1} {...propsTrainig} key={0} isCurrent={0 === this.state.current} onLoadedFullText={this.onLoadedFullText}/>),
            (<Training2 ref={this.refTraining2} {...propsTrainig} key={1} isCurrent={1 === this.state.current} />),
            (<Training3 ref={this.refTraining3} {...propsTrainig} key={2} isCurrent={2 === this.state.current} />),
            (<Training4 ref={this.refTraining4} {...propsTrainig} key={3} isCurrent={3 === this.state.current} sendMax={this.state.sendMax} sendCount={this.state.sendCount} records={this.props.records} onClickHelp={this.onClickHelp}/>),
            (<Training5 {...propsTrainig} key={4} isCurrent={4 === this.state.current} />),
        ];
        const propsSlider = {
            width: width,
            height: height,
            contents: contents,
            current: this.state.current,
            onChanged: this.onSliderChanged,
            onClickNext: this.onClickNext,
        }
        const propsHeader = {
            current: this.state.current,
            maxPage: 5,
            onClickMenu: this.onClickMenu,
            onClickHelp: this.onClickHelp,
        };
        const propsFooter = {
            current: this.state.current,
            maxPage: 5,
            onClickPrev: this.onClickPrev,
            onClickNext: this.onClickNext,
            onClickBack: this.onClickBack,
        };
        const propsHelp = {
            display: this.state.helpDisplay,
            closeHelp: this.closeHelp,
            page: this.state.current + 1,
            voiceChangeMark: this.state.voiceChangeMark,
        };
        return (
            <Body>
                <HeaderTraining {...propsHeader} />
                <Content Width={width} Height={height}>
                    <Slider ref={this.refSlider} {...propsSlider} />
                </Content>
                <FooterTraining {...propsFooter} />
                <LoadingView Display={this.props.loading} />
                <HelpDialog {...propsHelp} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        sendCount: store.login.sendCount,
        sendMax: store.login.sendMax,
        subject: store.subject.subject,
        vocabulary: store.vocabulary.vocabulary,
        chunk: store.chunk.chunk,
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
        playbackRate: store.setting.playbackRate,
        records: store.recording.records,
    }
};

const connectedTraining = connect(mapStateToProps)(Training);
export { connectedTraining as Training };

const Body = styled.div`
`;
const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
`;
const SliderContents = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
`;
